
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_14j6w_40",
  "outline": "awsui_outline_4yi2u_14j6w_73",
  "toggle-control": "awsui_toggle-control_4yi2u_14j6w_95",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_14j6w_115",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_14j6w_118",
  "toggle-control-readonly": "awsui_toggle-control-readonly_4yi2u_14j6w_124",
  "toggle-handle": "awsui_toggle-handle_4yi2u_14j6w_133",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_14j6w_158",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_14j6w_165",
  "toggle-handle-readonly": "awsui_toggle-handle-readonly_4yi2u_14j6w_169",
  "awsui-toggle-tail-off": "awsui_awsui-toggle-tail-off_4yi2u_14j6w_1",
  "awsui-toggle-tail-on": "awsui_awsui-toggle-tail-on_4yi2u_14j6w_1"
};
  